import styled from "@emotion/styled";
import {
  Collapse,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { SideMenu } from "./index";

const BottomMenuListItem = (props: { sideMenuItem: SideMenu }) => {
  const navigate = useNavigate();

  const SidebarListItemButton = styled(ListItemButton)(() => ({
    color: "white",
    display: "flex",
    justifyContent: "center",
    alignItems: 'center',
    maxWidth: '20%',
  }));

  const SidebarListItemIcon = styled(ListItemIcon)(() => ({
    color: "white",
    minWidth: "10px",
  }));

  
  return (
      <>
        <Tooltip title={props?.sideMenuItem?.name} placement={'top'}>
            <SidebarListItemButton
            onClick={() => {
                navigate(props.sideMenuItem?.url ?? "");
            }}
            >
              <SidebarListItemIcon>{props.sideMenuItem?.icon}</SidebarListItemIcon>
            </SidebarListItemButton>
        </Tooltip>
        
      </>
  );
};

export default BottomMenuListItem;